<button
  [class]="buttonClasses"
  [ngStyle]="buttonStyles"
  [disabled]="disabled()"
  (click)="onClick($event)"
>
  @if (icon() && iconPosition() === 'left') {
    <mat-icon class="btn-icon btn-icon--left">{{ icon() }}</mat-icon>
  }
  @if (text()) {
    <span class="btn-text">{{ text() }}</span>
  }
  @if (icon() && iconPosition() === 'right') {
    <mat-icon class="btn-icon btn-icon--right">{{ icon() }}</mat-icon>
  }
  @if (icon() && !text()) {
    <mat-icon class="btn-icon">{{ icon() }}</mat-icon>
  }
</button>
